import { Overlay } from "@components/Overlay";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { LogoutConfirmationModalProps } from "./types";

export const LogoutConfirmationModal = ({ callback }: LogoutConfirmationModalProps) => {
  const { dismiss } = useModal();

  const handleLogout = () => {
    dismiss();
    callback?.();
  };

  return (
    <Overlay
      title={i18n.t(Translations.LogoutConfirmationModalTitle)}
      subtitle={i18n.t(Translations.LogoutConfirmationModalSubtitle)}
      cta={{
        primary: {
          title: i18n.t(Translations.LogoutConfirmationModalPrimaryCTA),
          onClick: handleLogout,
        },
        secondary: {
          title: i18n.t(Translations.LogoutConfirmationModalSecondaryCTA),
          onClick: dismiss,
        },
      }}
      horizontal
    />
  );
};
